module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-compact-down-8ec3faed.svg";